import React from 'react';
import { Grid, Typography } from 'web-library';
import { CommonErrorResponse, GenericErrorResponse } from '../api';

export interface HandleErrorsProps{
  /** to define errors type
   * */
  errorType: 'text'|'box'

  /** to define error response
   * */
  errorResponse: GenericErrorResponse | CommonErrorResponse
}

/** reusable error handling component
 * * */
const HandleErrors: React.FC<HandleErrorsProps> = (props: HandleErrorsProps) => {

  const { errorType = 'text', errorResponse } = props;

  return (<Grid xs={12} md={8}>
      {errorType === 'text' && <Typography id='error-text' variant='body1' color='error'>{errorResponse.message}</Typography>}
    </Grid>
  )
}
export default HandleErrors;
